import React, { useEffect, useState } from "react";
import axios from "axios";

import TableRow from "../Home/TableRow";
import NotFound from "../Home/NotFound";
import Loader from "../Layout/Loader";
import "../Home/home.css";

export default function Home() {
  const param = new URLSearchParams(window.location.search);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  async function getRecord(path) {
    try {
      setLoading(true);
      const response = await axios.get(
        process.env.REACT_APP_BACKEND + "/record",
        {
          headers: {
            path: path,
          },
        }
      );
      setData(response.data?.update);
    } catch (error) {
      console.log({ error });
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    const path = param.get("code");
    if (path) {
      getRecord(path);
    }
  }, [param.get("code")]);
  console.log({ loading, data });

  return (
    <>
      {loading && <Loader />}
      <div className="home-container">
        <div className="home-main" style={{ paddingBottom: !data && 0 }}>
          <div className="logo">
            <img src="/logo.png" alt="" />
          </div>
          <h1>Welcome to IBCC Portal for Digital Verification</h1>
          {data && (
            <h3>
              This Certificate is attested by IBCC to{" "}
              <span>{data["Student Name"]}</span>.
            </h3>
          )}
        </div>
        {data && (
          <div className="table-main">
            {Object.entries(data).map((item, index) => (
              <TableRow key={index} item={item} />
            ))}
          </div>
        )}
        {!loading && !data && <NotFound />}
        <div className="note">
          <p>
            Note - Please compare the certificate data from the above mention
            data stored in IBCC database, provide your email address and get the
            verification reply from info@ibcc.edu.pk.
          </p>
          <strong>
            For More Information, You can visit IBCC Office, IBCC Website or
            Contact IBCC UAN Number 051- 111 114 222
          </strong>
        </div>
      </div>
    </>
  );
}
